export default __webpack_public_path__ + "static/media/information--street-name-three-lines--g1.80615ed6.png";